import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { CMSAuthService } from './essentials/cms/auth/cms-auth.service';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppInterceptor implements HttpInterceptor {
  private squidexBaseUrl = environment.configCMS.endPointAPI;
  private tokenExpirationDate = 0;
  private token = '';

  constructor(private cmsAuthService: CMSAuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isSquidexReq(req.url)) {
      return next.handle(req);
    }

    if (this.isSquidexConfigReq(req)) {
      return next.handle(req);
    }

    if (
      this.isSquidexReq(req.url) &&
      this.isTokenReq(req.url) &&
      this.isTokenValid()
    ) {
      req.headers.append('Authorization', `${this.token}`);
      return next.handle(req);
    }

    return from(this.asyncHandleAccess(req, next));
  }

  private async asyncHandleAccess(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Promise<HttpEvent<any>> {
    const res = await this.cmsAuthService.auth().toPromise();
    this.token = res.body.token_type + ' ' + res.body.access_token;
    this.updateTokenExpirationDate(res.body.expires_in);

    let changedRequest = this.getHeaders(req);
    if (this.isSquidexPreviewReq(changedRequest)) {
      changedRequest = this.getHeadersPreview(changedRequest);
    }
    return next.handle(changedRequest).toPromise();
  }

  private getHeaders(req: HttpRequest<any>): HttpRequest<any> {
    const headerSettings: { [name: string]: string | string[] } = {};
    const headerENUM = { AUTH: 'Authorization', CONTENT_TYPE: 'Content-Type' };

    req.headers.keys().forEach((key) => {
      headerSettings[key] = req.headers.getAll(key);
    });

    headerSettings[headerENUM.AUTH] = this.token;
    headerSettings[headerENUM.CONTENT_TYPE] = 'application/json; charset=utf-8';

    const headers = new HttpHeaders(headerSettings);
    return req.clone({ headers });
  }

  private getHeadersPreview(req: HttpRequest<any>): HttpRequest<any> {
    const headerSettings: { [name: string]: string | string[] } = {};

    req.headers.keys().forEach((key) => {
      headerSettings[key] = req.headers.getAll(key);
    });

    headerSettings['X-Unpublished'] = '1';

    const headers = new HttpHeaders(headerSettings);
    return req.clone({ headers });
  }

  private updateTokenExpirationDate(time: number): void {
    this.tokenExpirationDate =
      time !== this.tokenExpirationDate ? time : this.tokenExpirationDate;
  }

  private isTokenValid() {
    const now = Date.now();
    return (
      this.tokenExpirationDate > 0 || now + this.tokenExpirationDate <= now
    );
  }

  private isSquidexReq(url: string): boolean {
    return url.includes(this.squidexBaseUrl);
  }

  private isTokenReq(url: string): boolean {
    return url.includes('token');
  }

  private isSquidexConfigReq(req: HttpRequest<any>): boolean {
    try {
      const client_id = req.body.get('client_id');
      return (
        client_id.includes(environment.configSite.CLIENT_ID) ||
        req.url.includes(environment.configSite.endPointAPP)
      );
    } catch (e) {
      return req.url.includes(environment.configSite.endPointAPP);
    }
  }

  private isSquidexPreviewReq(req: HttpRequest<any>): boolean {
    return req.body?.query &&
      window.location.toString().indexOf('preview') > 0;
  }
}
